import { Box, Paper, Typography } from "@mui/material";

interface Props {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** Titled bordered card used for each section of the Settings tab. */
export default function SectionCard({ title, action, children }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 1.5,
        }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
        {action}
      </Box>
      {children}
    </Paper>
  );
}
